module.exports = __webpack_public_path__ + "static/media/3.613347e2.jpg";